var platform = "portal";
var platformNames = [];

/**
 * GLOBAL FUNCTION to set global vars. Inspired from IONIC isPlaform() mechanism. They can be initialised with values coming from
 * - Webpack DefinePlugin (eleda)
 * - Manually from startup scripts (eleda-mobile)
 * @param {*} platformValue
 * @param {*} platformNamesValue
 */
export function INIT_ENV_VARS(platformValue, platformNamesValue) {
  platform = platformValue;
  platformNames = platformNamesValue;
}
/**
 * Get name of principal target platform ("portal" or "mobile" ...)
 * @returns string
 */
export function GET_PLATFORM() {
  return platform;
}

/**
 * get list of platform names : inspired from IONIC getPlatforms() method (["ios","webmobile"])
 * @returns Array
 */
export function GET_PLATFORM_NAMES() {
  return platformNames;
}

export function ISPLATFORM_NAME(name) {
  return platformNames.includes(name);
}
